import styled from 'styled-components';

const StyledNoMenuOptions = styled.div`
  text-align: center;
  padding: 8px 12px;
  font-size: 1.25rem;
  margin-top: .25rem;
  margin-bottom: .25rem;
  color: hsl(0, 0%, 60%);
`;

const StyledMenuOptionWrapper = styled.div`
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  position: relative;
  background-color: #fff;
  padding-top: 4px;
  padding-bottom: 4px;
  max-height: 300px;

  .option {
    cursor: pointer;
    display: block;
    font-size: inherit !important;
    user-select: none;
    padding: 6px 12px;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    color: #495057;
    background-color: transparent;

    &.focused {
      background-color: #ffdce0;
    }

    &:hover {
      color: #495057;
      background-color: #ffdce0;
    }

    &.selected {
      color: #fff;
      background-color: #db011c;

      &:hover {
        color: #fff;
        background-color: #db011c;
      }
    }

    &.fixed+:not(.fixed)::before {
      content: '';
      position: absolute;
      margin-top: -6px;
      left: 0.1em;
      width: 100%;
      border-top: dashed 0.075em black;
    }
  }

  & .windowed-list {
    padding-top: 0px !important;
    padding-bottom: 0px !important;

    & > div {
      overflow: hidden !important;
      -webkit-overflow-scrolling: touch !important;
      position: relative;
      padding-top: 4px !important;
      padding-bottom: 4px !important;

      > div {
        text-overflow: ellipsis;
        overflow: hidden !important;
        white-space: nowrap; 
      }
    }
  }
`;

export {
  StyledNoMenuOptions,
  StyledMenuOptionWrapper,
};